/* Opening shot: the sun watches your cursor and blinks, clouds swing on their threads, the land shifts with the pointer,
   friends take turns hopping up from behind the hills; click one and it jumps and says hi. */
(function () {
  'use strict';
  var WH = window.WH;
  if (!WH) return;
  WH.register('hero', function (sec) {
    var eyes = Array.prototype.slice.call(sec.querySelectorAll('[data-eye]'));
    var glints = eyes.map(function (e) { return e.querySelector('b'); });
    var clouds = Array.prototype.slice.call(sec.querySelectorAll('[data-cloud]'));
    var layers = Array.prototype.slice.call(sec.querySelectorAll('[data-layer]'));
    var friends = Array.prototype.slice.call(sec.querySelectorAll('[data-friend]'));
    var px = window.innerWidth * 0.3, py = window.innerHeight * 0.6, lx = 0, visible = true;

    window.addEventListener('pointermove', function (e) { px = e.clientX; py = e.clientY; }, { passive: true });
    /* eye centres in page coordinates, measured once (the sun never moves), so frames don't force layout */
    var eyeAt = [];
    function measureEyes() { var y = window.scrollY; eyeAt = eyes.map(function (e) { var r = e.getBoundingClientRect(); return { x: r.left + r.width / 2, y: r.top + r.height / 2 + y, w: r.width, h: r.height }; }); }
    measureEyes();
    window.addEventListener('resize', measureEyes);
    window.addEventListener('load', measureEyes);
    var loop = null;
    /* off screen nothing here needs to move: the hop loop pauses too (it used to keep repainting while you were further down) */
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (loop) { if (visible) loop.resume(); else loop.pause(); } }).observe(sec);

    /* blink now and then (twice, sometimes) */
    (function blink() {
      setTimeout(function () {
        if (visible) {
          eyes.forEach(function (e) { e.classList.add('is-blink'); });
          setTimeout(function () { eyes.forEach(function (e) { e.classList.remove('is-blink'); }); }, 140);
          if (Math.random() < 0.3) setTimeout(function () { eyes.forEach(function (e) { e.classList.add('is-blink'); }); setTimeout(function () { eyes.forEach(function (e) { e.classList.remove('is-blink'); }); }, 120); }, 320);
        }
        blink();
      }, WH.rand(2200, 5200));
    })();

    if (!WH.reduce) {
      WH.onTick(function (dt, now) {
        if (!visible) return;
        /* eyes: the glint slides toward the pointer */
        var sy = window.scrollY;
        eyeAt.forEach(function (r, i) {
          var dx = px - r.x, dy = py - (r.y - sy), d = Math.max(1, Math.hypot(dx, dy)), k = Math.min(1, d / 260);
          glints[i].style.transform = 'translate(' + (dx / d * k * r.w * 0.32).toFixed(1) + 'px,' + (dy / d * k * r.h * 0.3).toFixed(1) + 'px)';
        });
        /* clouds swing on their threads */
        clouds.forEach(function (c, i) { c.style.transform = 'rotate(' + (Math.sin(now * 0.00192 + i * 2.1) * 2.4).toFixed(2) + 'deg)'; });
        /* the land leans toward the pointer */
        lx += ((px / window.innerWidth - 0.5) - lx) * WH.ease(0.35, dt);
        layers.forEach(function (l) { var d = parseFloat(l.getAttribute('data-layer')) || 0; l.style.transform = 'translateX(' + (-lx * d * 46).toFixed(1) + 'px)'; });
      });
    }

    /* friends take turns hopping */
    var bodies = friends.map(function (b) { return b.querySelector('[data-friend-body]'); });
    function hop(body, big) {
      var h = big ? -78 : -40;
      return gsap.timeline()
        .to(body, { scaleX: 1.12, scaleY: 0.86, duration: 0.17, ease: WH.sm('power1.out', 0.17) })
        .to(body, { yPercent: h, scaleX: 0.92, scaleY: 1.1, rotation: big ? WH.rand(-12, 12) : 0, duration: big ? 0.42 : 0.34, ease: WH.sm('power2.out', 0.4) })
        .to(body, { yPercent: 0, scaleX: 1, scaleY: 1, rotation: 0, duration: big ? 0.34 : 0.3, ease: WH.sm('power2.in', 0.3) })
        .to(body, { scaleX: 1.1, scaleY: 0.88, duration: 0.09, ease: 'none' })
        .to(body, { scaleX: 1, scaleY: 1, duration: 0.17, ease: WH.sm('power1.out', 0.17) });
    }
    if (WH.anim && bodies.length) {
      loop = gsap.timeline({ repeat: -1, repeatDelay: 0.6, delay: 1.2, paused: !visible });
      var order = bodies.map(function (b, i) { return i; }).sort(function () { return Math.random() - 0.5; });
      order.forEach(function (i, k) { loop.add(hop(bodies[i]), k * 0.75); });
    }

    friends.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        if (WH.anim) {
          gsap.killTweensOf(bodies[i]);
          hop(bodies[i], true);
          var r = btn.getBoundingClientRect(); WH.puff(r.left + r.width / 2, r.top + r.height * 0.4, 7);
        }
        WH.sound.play('squeak');
        say(btn);
      });
    });
    function say(btn) {
      var old = sec.querySelector('.wh-bubble');
      if (old) old.remove();
      var b = document.createElement('span');
      b.className = 'wh-bubble';
      b.innerHTML = '';
      b.appendChild(document.createTextNode((sec.getAttribute('data-hi') || 'Hi! I’m') + ' ' + btn.getAttribute('data-name') + '. '));
      var a = document.createElement('a'); a.href = btn.getAttribute('data-url'); a.textContent = (sec.getAttribute('data-meet') || 'Meet me') + ' →';
      b.appendChild(a);
      /* the bubble goes on the section itself, above the copy block: on phones it lands on the hero buttons, which would
         otherwise take the tap meant for "Meet me" */
      sec.appendChild(b);
      var r = btn.getBoundingClientRect(), s = sec.getBoundingClientRect();
      b.style.bottom = 'auto';
      b.style.zIndex = 6;
      b.style.left = Math.max(8, Math.min(s.width - b.offsetWidth - 8, r.left - s.left + r.width * 0.3)) + 'px';
      b.style.top = (r.top - s.top - b.offsetHeight - 6) + 'px';
      if (WH.anim) gsap.fromTo(b, { scale: 0, rotation: -12, transformOrigin: '20% 100%' }, { scale: 1, rotation: 0, duration: 0.4, ease: WH.sm('back.out(2.4)', 0.4) });
      setTimeout(function () { if (b.parentNode) { if (WH.anim) gsap.to(b, { scale: 0, duration: 0.2, ease: WH.sm('power1.in', 0.2), onComplete: function () { b.remove(); } }); else b.remove(); } }, 3600);
    }

    sec.querySelectorAll('[data-tour]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.querySelector(a.getAttribute('href'));
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: WH.reduce ? 'auto' : 'smooth' });
      });
    });
  });
})();
